import {
    AfterViewInit,
    Component,
    DoCheck,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { PartialObserver, Subscription } from 'rxjs';
import { SelectListOption } from '../../shared/shared.types';
import { BaseInputComponent } from '../base-input/base-input.component';
import { SelectInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class SelectComponent extends BaseInputComponent implements OnInit, AfterViewInit, DoCheck, OnDestroy {
    @Input() input: SelectInputType;
    @ViewChild(MatSelect) matSelect: MatSelect;
    loading: boolean = true;
    options: Array<SelectListOption> = [];
    errorLoading: boolean;
    notAuthorized: boolean;
    private subscription$: Subscription;
    subscriptionObserver: PartialObserver<Array<SelectListOption>> = {
        next: (options) => {
            this.options = options;
            this.loading = false;
            if (this.options && this.options.length === 1 && this.input.autoSelectIfOnlyOne) {
                let markDirty: boolean = false;
                if (this.input.isMultiple) {
                    markDirty = this.input.control.value !== [this.options[0].value];
                    this.input.control.setValue([this.options[0].value]);
                    if (this.input.emitEventOnAutoSelect) {
                        this.emitChangeEvent([this.options[0].value]);
                    }
                } else {
                    markDirty = this.input.control.value !== this.options[0].value;
                    this.input.control.setValue(this.options[0].value);
                    if (this.input.emitEventOnAutoSelect) {
                        this.emitChangeEvent(this.options[0].value);
                    }
                }
                if (markDirty) {
                    this.input.control.markAsDirty();
                }
            }
        },
        error: (error) => {
            if (error.status === 403) {
                this.notAuthorized = true;
            }
            this.errorLoading = true;
            this.loading = false;
        }
    };

    constructor(private questionStateService: QuestionStateService) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
        this.subscribe();
    }

    ngAfterViewInit() {
        if (this.matSelect) {
            this.inputIdEvent.emit(this.matSelect.id);
        }
    }

    ngDoCheck() {
        if (this.input.updateOptions) {
            this.input.updateOptions = false;
            this.loading = true;
            this.subscribe();
        }
    }

    subscribe() {
        if (this.subscription$) {
            this.subscription$.unsubscribe();
        }
        if (this.input.options$) {
            this.subscription$ = this.input.options$.subscribe(this.subscriptionObserver);
        } else if (this.input.optionsCallBack) {
            this.subscription$ = this.input.optionsCallBack.function
                .call(this.input.optionsCallBack.this)
                .subscribe(this.subscriptionObserver);
        }
    }

    ngOnDestroy() {
        if (this.subscription$) {
            this.subscription$.unsubscribe();
        }
    }

    selectChange($event: MatSelectChange) {
        this.inputValueChangeEventEmitter.emit({
            payload: $event,
            input: this.input
        });
    }

    private emitChangeEvent(value: any) {
        this.inputValueChangeEventEmitter.emit({
            payload: {
                source: this.matSelect,
                value: value
            } as MatSelectChange,
            input: this.input
        });
    }

    clearValue() {
        this.input.control.setValue(null);
        this.emitChangeEvent(null);
        this.input.control.updateValueAndValidity();
    }
}
